import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  createSortByAttr,
  DEBITOR_STATUS_LABELS,
  PageHeight40,
  scrollToTop,
  TableEmptyMessage,
} from "../../../components/Utils";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { loadDebitorMapping } from "../actions";
import TablePageReport from "../../../components/TablePageReport";

const frontload = async (props) => await props.getDebitorMapping();

const mapStateToProps = (state) => {
  return {
    isLoading: state.debitorMapping.loading,
    debitorMapping: state.debitorMapping.mappings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getDebitorMapping: (...args) => dispatch(loadDebitorMapping(...args)),
});

const DebitorMappingTable = ({
  isLoading,
  debitorMapping,
  rows,
  className,
}) => {
  const [first, setFirst] = useState(0);

  useEffect(() => {
    scrollToTop();
  });

  const onPage = (event) => {
    setFirst(event.first);
  };

  console.log("DebitorMappingTable.render()", {
    isLoading,
    debitorMapping,
    rows,
    className,
  });

  const data = debitorMapping
    .map((item, index) => {
      const copy = JSON.parse(JSON.stringify(item));
      const { street, house, areacode, city } = item;
      const addressStr = `${item.name}, ${street} ${house}, ${areacode} ${city}`;
      const status = item.status || DEBITOR_STATUS_LABELS[item.status_id];
      return {
        ...copy,
        regionName: item.region || item.regionName,
        index,
        addressStr,
        status,
      };
    })
    .sort(createSortByAttr("debitorKey"));

  return (
    <PageHeight40 className={`modem-table clearfix ${className}`}>
      <DataTable
        value={data}
        paginator={data.length > rows}
        first={first}
        onPage={onPage}
        paginatorLeft={
          <TablePageReport
            className="pad-lft"
            totalRecords={data.length}
            filteredRecords={data.length}
            first={first}
            rows={rows}
            emptyText="Kein Mapping"
            itemName="Debitor-Mapping"
            itemNamePlural="Debitor-Mapping"
          />
        }
        rows={rows}
        emptyMessage={
          isLoading ? null : (
            <TableEmptyMessage itemNamePlural="Debitor-Mapping" />
          )
        }
      >
        <Column
          field="region"
          header="Region"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
          style={{ textAlign: "center", width: "12rem" }}
        />
        <Column
          field="storageLocation"
          header="Storage Location"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
          style={{ textAlign: "center", width: "12rem" }}
          body={(row) => (
            <span
              className="display-inline-block"
              style={{ textAlign: "left", width: "4rem" }}
            >
              {row.storageLocation}
            </span>
          )}
        />
        <Column
          field="companyName"
          header="Firma"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
          // style={{width: '25%'}}
        />
      </DataTable>
    </PageHeight40>
  );
};

DebitorMappingTable.propTypes = {
  isLoading: PropTypes.bool,
  debitorMapping: PropTypes.arrayOf(
    PropTypes.shape({
      debitorKey: PropTypes.string,
      storage_location: PropTypes.string,
    }),
  ),
  getDebitorMapping: PropTypes.func.isRequired,
  rows: PropTypes.number,
  className: PropTypes.string,
};

DebitorMappingTable.defaultProps = {
  rows: 10,
  className: "",
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(DebitorMappingTable),
);
